import React from "react";
import { useTranslation } from "react-i18next";

import img1 from "@/assets/explore-maatra/hospitalisation-img1.png";
import img2 from "@/assets/explore-maatra/hospitalisation-img2.png";
import img3 from "@/assets/explore-maatra/hospitalisation-img3.png";
import { useS3VideoUrl } from "@/hooks/useS3VideoUrl";
import {
  VIDEO_HEALTH_SUMMARY_S3_FILE,
  VIDEO_SEARCH_S3_FILE,
  VIDEO_REMINDER_S3_FILE,
} from "@/utils/constants";

import ExploreScreen, { ExploreCard } from "./ExploreScreen";

const BEIGE =
  "radial-gradient(ellipse at center, rgba(236,221,184,1) 0%, rgba(245,235,225,1) 100%)";
const PINK =
  "radial-gradient(ellipse at center, rgba(245,182,231,1) 0%, rgba(244,215,233,1) 100%)";
const PURPLE =
  "radial-gradient(ellipse at center, rgba(209,193,237,1) 0%, rgba(242,225,245,1) 100%)";

const Hospitalisation: React.FC = () => {
  const { t } = useTranslation();

  const healthSummaryVideoUrl = useS3VideoUrl(VIDEO_HEALTH_SUMMARY_S3_FILE);
  const searchVideoUrl = useS3VideoUrl(VIDEO_SEARCH_S3_FILE);
  const reminderVideoUrl = useS3VideoUrl(VIDEO_REMINDER_S3_FILE);

  const cards: [ExploreCard, ExploreCard, ExploreCard] = [
    {
      img: img1,
      title: t("auth.hospitalisation.cards.c1"),
      thumbGradient: BEIGE,
      videoUrl: healthSummaryVideoUrl,
      imgStyle: { width: "82px", height: "86px", left: "0px", top: "-8px" },
    },
    {
      img: img2,
      title: t("auth.hospitalisation.cards.c2"),
      thumbGradient: PINK,
      videoUrl: searchVideoUrl,
      imgStyle: { width: "86px", height: "100px", left: "-1px", top: "1px" },
    },
    {
      img: img3,
      title: t("auth.hospitalisation.cards.c3"),
      thumbGradient: PURPLE,
      videoUrl: reminderVideoUrl,
      imgStyle: { width: "181px", height: "122px", left: "-1px", top: "0px" },
    },
  ];

  return (
    <ExploreScreen
      pill={t("auth.hospitalisation.pill")}
      bodyText={t("auth.hospitalisation.bodyText")}
      cards={cards}
    />
  );
};

export default Hospitalisation;
